(function(){
    angular
        .module('appback')
        .directive('ngFicheros', ficheros);

        ficheros.$inject = ['Upload','ResultadosService','$timeout'];
        function ficheros(Upload,ResultadosService,$timeout){
            return {
	            //require: 'ngModel',
	            templateUrl: '/backend/resultadopeticion/template?name=ficheros.twig',
		          scope: {
                  //ngModel : '=',
                  item: '=',
                  animal: '='
              	},
            	link: function (scope, element, $attrs) {
                    console.log("ficheros");
		            return $timeout(function () {
		            	if(!scope.item.resultado){
			            		scope.item.resultado = { extra : { resultado : { ficheros : [], cert_file_id : [] }}};
		            	}else{
			            	if(!scope.item.resultado.extra){
			            		scope.item.resultado.extra = { resultado : { ficheros : [], cert_file_id : [] }};
				            }
				        }
				        //console.log("info",scope.item.resultado.extra.resultado.info);
				        /*if(angular.isUndefined(scope.item.resultado.extra.resultado.info)){
				        	scope.item.resultado.extra.resultado.info = scope.item.extra[0].info;
				        }*/

				        scope.borrarFichero = function(index){
				        	scope.item.resultado.extra.resultado.ficheros.splice(index,1);
				        }

						scope.borrarFicheroCer = function(index){
				        	scope.item.resultado.extra.resultado.cert_file_id.splice(index,1);
				        }

				        scope.uploadFiles = function (files) {
				          if (files && files.length) {
				            for (var i = 0; i < files.length; i++) {
				              Upload.upload({
				                    url: '/backend/resultadopeticion/subirfichero',
				                    data: { file: files[i] }
				                }).then(function (resp) {
				                    //onsole.log(resp);
				                    scope.item.resultado.extra.resultado.ficheros.push(resp.data);
				                    //console.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data);
				                }, function (resp) {
				                    //console.log('Error status: ' + resp.status);
				                }, function (evt) {
				                    var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
				                    //console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
				                });
				            }
				            
				          }
				        }

				        scope.borrarFicheroCert = function(index){
				        	scope.item.resultado.extra.resultado.ficheros.splice(index,1);
				        }

				        scope.uploadFilesCert = function (files) {
				          if (files && files.length) {
				            for (var i = 0; i < files.length; i++) {
				              Upload.upload({
				                    url: '/backend/resultadopeticion/subirfichero',
				                    data: { file: files[i] }
				                }).then(function (resp) {
				                    //onsole.log(resp);
				                    scope.item.resultado.extra.resultado.cert_file_id.push(resp.data);
				                    //console.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data);
				                }, function (resp) {
				                    //console.log('Error status: ' + resp.status);
				                }, function (evt) {
				                    var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
				                    //console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
				                });
				            }
				            
				          }
				        }
		            	
			        });
		        }
          }
      }
})();